<template>
  <div class="row">

    <div class="col-md-4" v-bind:class="{[compTitleBg] : true, [compTitleText] : true}">
      <div class="row align-items-center title-wrap">
        <div class="col">
          <div class="title text-center">{{title}}</div>

          <template v-if="title2">
            <div class="title margin-top-05">{{title2}}</div>
          </template>

          <template v-if="title3">
            <div class="title">{{title3}}</div>
          </template>

          <div class="subtitle text-center">{{subtitle}}</div>
        </div>
      </div>
    </div>

    <div class="copy col-md-8 border-1" v-bind:class="{[compBgColor] : true, [compTextColor] : true}">
      <slot></slot>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      defaultBgColor: "bg-light",
      defaultTextColor: "text-black",
      defaultTitleBg: "bg-light",
      defaultTitleText: "text-primary",
      compBgColor: "",
      compTextColor: "",
      compTitleBg: "",
      compTitleText: ""
    }
  },
  props: ['title','title2','title3','subtitle','title-bg','title-color',
          'bg-color','text-color',],
  created: function() {
    this.makeTitleBg()
    this.makeTitleText()
    this.makeBgColor()
    this.makeTextColor()
  },
  methods: {
    makeTitleBg: function() {
      if (this.titleBg != null && this.titleBg != "") {
        this.compTitleBg = "bg-" + this.titleBg
      } else {
        this.compTitleBg = this.defaultTitleBg
      }
    },
    makeTitleText: function() {
      if (this.titleColor != null && this.titleColor != "") {
        this.compTitleText = "text-" + this.titleColor
      } else {
        this.compTitleText = this.defaultTitleText
      }
    },
    makeBgColor: function() {
      if (this.bgColor != null && this.bgColor != "") {
        this.compBgColor = "bg-" + this.bgColor
      } else {
        this.compBgColor = this.defaultBgColor
      }
    },
    makeTextColor: function() {
      if (this.textColor != null && this.textColor != "") {
        this.compTextColor = "text-" + this.textColor
      } else {
        this.compTextColor = this.defaultTextColor
      }
    }
  }
}
</script>

<style scoped>
  .title-wrap {
    height: 100%;
    min-height: 100px;
  }

  .title {
    font-size: 1.75em;
    font-weight: bold;
  }

  .subtitle {
    font-size: 1.25em;
    font-weight: bold;
    padding: 0.5em 0 0 0;
  }

  .copy {
    line-height: 1.5em;
    padding: 0 1.0em 1.0em 1.0em;
  }

  .copy p {
    margin: 1.0em 1.0em 0 0;
  }
</style>
